import '../Navbar/styles.css';
import { useCallback, useState } from 'react';

const navItems = [
  { label: 'Strategie', href: '/' },
  { label: 'Historia', href: '/history' },
  { label: 'Backtests', href: '/backtests' },
  // { label: 'FAQ', href: '/' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleLogout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    window.location.href = "/";
  }, []);

  const handleNavigate = (href) => {
    window.location.href = href;
  };

  return (
    <nav className="navbar">
      <div className="navbar__brand">ML Strategy</div>

      <button className="navbar__toggle" onClick={toggleMenu} aria-label="Menu">
        &#9776;
      </button>

      <ul className={`navbar__menu ${menuOpen ? 'navbar__menu--open' : ''}`}>
        {navItems.map(({ label, href }) => (
          <li key={label} className="navbar__item">
            <button className="navbar__button" onClick={() => handleNavigate(href)}>
              {label}
            </button>
          </li>
        ))}
        <li className="navbar__item">
          <button className="navbar__button" onClick={handleLogout}>
            Wyloguj
          </button>
        </li>
      </ul>
    </nav>
  );
}
